import { createBrowserRouter } from 'react-router-dom';
import { AppLayout } from './layouts/AppLayout';
import { DashboardPage } from './pages/DashboardPage';
import { GroupsPage } from './pages/GroupsPage';

import { GroupDetailPage } from './pages/GroupDetailPage';
import { UserProfilePage } from './pages/UserProfilePage';
import { UsersPage } from './pages/UsersPage';
import { UserDetailPage } from './pages/UserDetailPage';
import { RolesPage } from './pages/RolesPage';
import { PermissionsPage } from './pages/PermissionsPage';
import { ResourceServersPage } from './pages/ResourceServersPage';
import { LoginPagesPage } from './pages/LoginPagesPage';
import { EmailTemplatesPage } from './pages/EmailTemplatesPage';
import { IdentityProvidersPage } from './pages/IdentityProvidersPage';
import { UmrsRolesPage } from './pages/UmrsRolesPage';
import { PlaygroundPage } from './pages/PlaygroundPage';

export const router = createBrowserRouter([
  {
    path: '/',
    element: <AppLayout />,
    children: [
      {
        index: true,
        element: <DashboardPage />,
      },
      {
        path: 'groups',
        element: <GroupsPage />,
      },
      {
        path: 'groups/:groupId',
        element: <GroupDetailPage />,
      },
      {
        path: 'profile',
        element: <UserProfilePage />,
      },
      {
        path: 'users',
        element: <UsersPage />,
      },
      {
        path: 'users/:userId',
        element: <UserDetailPage />,
      },
      {
        path: 'login-pages',
        element: <LoginPagesPage />,
      },
      {
        path: 'email-templates',
        element: <EmailTemplatesPage />,
      },
      {
        path: 'identity-providers',
        element: <IdentityProvidersPage />,
      },
      {
        path: 'umrs-roles',
        element: <UmrsRolesPage />,
      },
      {
        path: 'roles',
        element: <RolesPage />,
      },
      {
        path: 'permissions',
        element: <PermissionsPage />,
      },
      {
        path: 'resource-servers',
        element: <ResourceServersPage />,
      },
      {
        path: 'playground',
        element: <PlaygroundPage />,
      },
    ],
  },
]);
